import React, { Component } from "react";
import axios from "axios";
import LoadingScreen from "../../components/LoadingScreen";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faUserCog,
  faCog,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import Container from "../../components/Container";

class AdminViewBrief extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: [],
      brief: [],
      customer: null,
      isReady: 0,
      isPrint: false,
      alert: null,
      messages: null,
    };
    this.confirmLogout = this.confirmLogout.bind(this);
    this.getCustomerBrief = this.getCustomerBrief.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/admincre/whois`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          this.getCustomerBrief();
          var progress = this.state.isReady + 50;
          this.setState({
            user: response.data.user,
            isReady: progress,
          });
        } else {
          this.props.history.push("/login");
        }
      });
  }

  getCustomerBrief() {
    const { btype, briefid, customerid } = this.props.match.params;
    axios
      .get(
        `${window.localhost}/admincre/getbrief/${customerid}/${btype}/${briefid}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
          },
        }
      )
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          var progress = this.state.isReady + 50;
          console.log(response.data.brief);
          this.setState({
            brief: response.data.brief,
            customer: response.data.customer,
            isReady: progress,
          });
        } else {
          this.props.history.push("/");
        }
      });
  }

  confirmLogout() {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Logout"
        cancelBtnText="Batal"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu..."
        onConfirm={() => this.handleLogout()}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Apakah Anda yakin ingin Logout?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleLogout() {
    axios
      .get(`${window.localhost}/customer/logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          this.props.history.push("/login");
        }
      });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  render() {
    if (this.state.isReady !== 100) {
      return <LoadingScreen />;
    } else {
      const { customer, user, brief } = this.state;
      const navmenu = () => {
        return (
          <div className="dropdown">
            <button
              className="btn text-danger d-flex align-items-center dropdown-toggle"
              aria-current="page"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="me-2 d-md-flex d-none">{user.username}</span>
              <FontAwesomeIcon icon={faUserCircle} className="fs-3" />
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="dropdownMenuButton1"
            >
              {/* <li>
                <a className="dropdown-item disabled" href="#">
                  <FontAwesomeIcon icon={faUserCog} /> Info Pengguna
                </a>
              </li>
              <li>
                <a className="dropdown-item disabled" href="#">
                  <FontAwesomeIcon icon={faCog} /> Ganti Password
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li> */}
              <li>
                <button className="dropdown-item" onClick={this.confirmLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                </button>
              </li>
            </ul>
          </div>
        );
      };
      return (
        <div>
          {this.state.isPrint ? (
            ""
          ) : (
            <Header menu={navmenu()} destination={`/admincre`} />
          )}
          <div className="container wrapper-sm wrapper">
            <div className="col-md-8 mx-auto col-12 mb-5">
              {this.state.isPrint ? (
                <div className="px-3 mb-4">
                  <div className="card-body">
                    <div className="row row-cols-2">
                      <div className="col">
                        <img
                          src="/img/creatifa-logo-with-text.png"
                          height="50"
                          className=""
                          alt=""
                        />
                      </div>
                      <div className="col">
                        <span className="float-end fw-bold fs-5 font-poppins">
                          Logo Brief App
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="row px-0">
                <h1 className="px-0 text-center mb-3">
                  <span className="cf-header px-2 fw-bold">Data Customer</span>
                </h1>
                <hr />
              </div>

              <div className="row row-cols-md-2 row-cols-1 g-4">
                <div className="col">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title text-danger">Nama Lengkap</h5>
                      <p>
                        <b>{customer.fullname}</b>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title text-danger">Institusi</h5>
                      <p>
                        <b>{customer.institusi}</b>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title text-danger">Email</h5>
                      <p>
                        <b>{customer.email}</b>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title text-danger">Nomor HP</h5>
                      <p>
                        <b>{customer.phone}</b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8 mx-auto col-12">
              <div className="row px-0">
                <h1 className="px-0 text-center mb-3">
                  <span className="cf-header px-2 fw-bold">
                    {customer.institusi}'s Logo Brief
                  </span>
                </h1>
                <hr />
              </div>

              <div className="row row-cols-1 g-4">
                {brief.map((brf, index) => (
                  <div className="col" key={index}>
                    <div className="card w-100">
                      <div className="row">
                        <div
                          className={
                            brf.question.answer_type === "image" ||
                            brf.answer_ref !== null
                              ? "col-8"
                              : "col-12"
                          }
                        >
                          <div className="card-body">
                            <h5 className="card-title text-danger">
                              {brf.question.label}
                            </h5>

                            {brf.question.answer_type === "image" ? (
                              <a
                                className="btn btn-sm btn-yellow"
                                href={`${
                                  window.localhost
                                }/brief/${customer.institusi.replace(
                                  / /g,
                                  "_"
                                )}/${brf.answer}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                Unduh Gambar
                              </a>
                            ) : (
                              <p>
                                <b>Jawab</b>: {brf.answer}
                              </p>
                            )}
                          </div>
                        </div>
                        {brf.question.answer_type === "image" ? (
                          <div className="col-4">
                            <img
                              src={`${
                                window.localhost
                              }/brief/${customer.institusi.replace(
                                / /g,
                                "_"
                              )}/${brf.answer}`}
                              className="img-fluid"
                              alt="Brief Attachment"
                            />
                          </div>
                        ) : (
                          ""
                        )}
                        {brf.answer_ref !== null ? (
                          <div className="col-4 py-4">
                            <img
                              src={`/img/${brf.answer_ref.answer_img}`}
                              className="img-fluid"
                              alt="Brief Attachment"
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row mt-4">
                <div className="d-flex justify-content-between">
                  <Link to={`/admincre`}>
                    <button className="btn btn-outline-danger fw-bold px-4">
                      Kembali
                    </button>
                  </Link>

                  <button
                    onClick={() => {
                      this.setState({ isPrint: true });
                      setTimeout(() => window.print(), 100);
                    }}
                    className="btn btn-outline-secondary shadow fw-bold px-4"
                  >
                    Simpan (pdf)
                  </button>
                </div>
              </div>
            </div>
          </div>
          {this.state.alert}

          <Footer />
        </div>
      );
    }
  }
}

export default AdminViewBrief;
